import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b1dad86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "forecast" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-icon" }),
  /*#__PURE__*/_createTextVNode(" 未来5天空气质量预报 ")
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["onMouseenter"]
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = { class: "status" }
const _hoisted_8 = { class: "forecast" }
const _hoisted_9 = { class: "temperature" }
const _hoisted_10 = {
  class: "icon",
  "aria-hidden": "true"
}
const _hoisted_11 = ["xlink:href"]
const _hoisted_12 = { class: "hover-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hover-title" }, "AQI范围", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hover-title" }, "首要污染物", -1))
const _hoisted_15 = { class: "first-pul" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hover-title" }, "出行建议", -1))

import {
  computed, onMounted, ref, watch,
} from 'vue';
import { Button, } from 'ant-design-vue';
import { useStore, } from 'vuex';
import moment from 'moment';
import qs from 'qs';
import {
  factorColorRender, factorTxtRender, weatherRender,fontColorRender,
} from '@/utils/index';
import 'moment/locale/zh-cn';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dateFormate = 'YYYY/MM/DD';
const dayFormate = 'dddd';

// 要素对应文字
const factorKey = {
  PM25: '<span>PM<sub>2.5</sub></span>',
  PM10: '<span>PM<sub>10</sub></span>',
  SO2: '<span>SO<sub>2</sub></span>',
  NO2: '<span>NO<sub>2</sub></span>',
  CO: 'CO',
  O3: '<span>O<sub>3</sub></span>',
};

// 鼠标enter的时候控制浮层显示
const detailSHow = ref('');

const store = useStore();

const regionId = computed<number>(() => store.state.OLMap.regionId) || 320100000000;

watch(regionId, (cur:number):void => {
  store.dispatch('gateway/loadWeatherList', qs.stringify({ regionId: cur, }));
});

/**
 * @todo 历史数据不确定几条
 */
const today = computed(() => ({ ...store.state.gateway.weatherList[0], }));

// const nextDays = computed(() => store.state.gateway.weatherList.slice(1, 5));
const nextDays = computed(() => store.state.gateway.weatherList);

const nextDaysOther = [{
  aqi: '0',
  aqiRange: '-',
  pollutant: '-',
  suggestion: '-',
  temperatureAm: '-',
  temperaturePm: '-',
  weatherAm: '-',
  weatherDate: '-',
  weatherPm: '-',
  windDirectionAm: '-',
  windDirectionPm: '-',
  windStrengthAm: '-',
  windStrengthPm: '-',
},
{
  aqi: '',
  aqiRange: '-',
  pollutant: '-',
  suggestion: '-',
  temperatureAm: '-',
  temperaturePm: '-',
  weatherAm: '-',
  weatherDate: '-',
  weatherPm: '-',
  windDirectionAm: '-',
  windDirectionPm: '-',
  windStrengthAm: '-',
  windStrengthPm: '-',
},
{
  aqi: '',
  aqiRange: '-',
  pollutant: '-',
  suggestion: '-',
  temperatureAm: '-',
  temperaturePm: '-',
  weatherAm: '-',
  weatherDate: '-',
  weatherPm: '-',
  windDirectionAm: '-',
  windDirectionPm: '-',
  windStrengthAm: '-',
  windStrengthPm: '-',
},
{
  aqi: '',
  aqiRange: '-',
  pollutant: '-',
  suggestion: '-',
  temperatureAm: '-',
  temperaturePm: '-',
  weatherAm: '-',
  weatherDate: '-',
  weatherPm: '-',
  windDirectionAm: '-',
  windDirectionPm: '-',
  windStrengthAm: '-',
  windStrengthPm: '-',
},];

/**
 * 天气和风速处理
 * @param {any} val 处理对象
 * @param {string}am 上午
 * @param {string} pm 夜里
 * @return {string} 处理返回值
 */
const weather = (val: any, am: string,pm:string):string => `${val[am]}${val[am] === val[pm] ?
  '' :
  `转${val[pm]}`}`;

onMounted(() => {
  if (regionId.value) {
    store.dispatch('gateway/loadWeatherList', qs.stringify({ regionId: regionId.value, }));
  }
});

/**
 * @todo 后端无数据处理
 */

return (_ctx: any,_cache: any) => {
  const _component_P = _resolveComponent("P")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nextDays) ? _unref(nextDays) : nextDaysOther, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: index,
          onMouseenter: ($event: any) => (detailSHow.value = item.weatherDate),
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (detailSHow.value = ''))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(moment)(item.weatherDate).format(dateFormate)), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(moment)(item.weatherDate).format(dayFormate)), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(item.aqi === '0' || item.aqi ? item.aqi : '暂无预报'), 1),
            _createElementVNode("div", {
              class: "btn",
              style: _normalizeStyle(item.aqi === '0' || item.aqi ?
            { backgroundColor: _unref(factorColorRender)(Number(item.aqi), 'aqi'),color:_unref(fontColorRender)(Number(item.aqi), 'aqi') } :
            {display:'none'})
            }, _toDisplayString(_unref(factorTxtRender)(Number(item.aqi === '0' || item.aqi  ?item.aqi : '-9999' ), 'aqi')), 5)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                _createElementVNode("use", {
                  "xlink:href": `#icon-${_unref(weatherRender)(item.weatherAm)}`
                }, null, 8, _hoisted_11)
              ])),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(item.temperaturePm) + "-" + _toDisplayString(item.temperatureAm) + "℃", 1),
                _createElementVNode("div", null, _toDisplayString(weather(item,'weatherAm','weatherPm')), 1)
              ])
            ]),
            _createElementVNode("div", null, _toDisplayString(item.windDirectionAm) + _toDisplayString(weather(item,'windStrengthAm','windStrengthPm')), 1)
          ]),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", null, _toDisplayString(item.aqiRange), 1),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pollutant.split(','), (i, index) => {
                    return (_openBlock(), _createBlock(_unref(Button), {
                      class: "btn",
                      type: "primary",
                      key: index,
                      innerHTML: factorKey[i]
                    }, null, 8, ["innerHTML"]))
                  }), 128))
                ]),
                _hoisted_16,
                _createVNode(_component_P, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.suggestion), 1)
                  ]),
                  _: 2
                }, 1024)
              ], 512), [
                [_vShow, detailSHow.value === item.weatherDate]
              ])
            ]),
            _: 2
          }, 1024)
        ], 40, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})